import { Omit } from '@40seas/entities/common';
import { InsuranceCompany } from './insurance.company.entity';
import { BaseEntityFieldsArray } from '@40seas/models';

export class CreateInsuranceCompanyDto extends Omit(InsuranceCompany, [...BaseEntityFieldsArray]) {}
